import Vue from "vue";
import Router from "vue-router";

import Home from "@/views/Home";
import Error404 from "@/views/Error404";
import Unauthorized from "@/views/Unauthorized";

import admRoutes from './adm-routes'
import masterRoutes from './master-routes'
import prdRoutes from "./prd-routes";
import reportRoutes from "./report-routes";
import quartzRoutes from "./quartz-routes";
import emRouters from "./em/index-em-routes";
import sithMesRouters from "./sithMes/index-sithMes-routes";
import sithMesIIRouters from "./sithMesII/index-sithMesII-routes";
import layoutRouters from "./layout-routes"
import mintalMesRouters from "./mintalMes/index-mintalMes-routes"
import partyBuilding from "./party-building/moduleIndex-router-party-building"
import EmLogin from '../../src/views/em/admin/Emlogin'
import emAssistantRoutes from "@/router/emAssistant/index-emAssistant-routes";

// import inventoryRoutes from "./inventory-routes";


Vue.use(Router);
let jwt = localStorage['em_sso_token']

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
        path: "/",
        name: "home",
        component: Home,
        meta: {requiresAuth: true, roles: ['mmf']},
        children: []
    },
        ...admRoutes,
        ...masterRoutes,
        ...prdRoutes,
        // ...inventoryRoutes,
        ...reportRoutes,
        ...quartzRoutes,
        ...emRouters,
        ...emAssistantRoutes,
        ...sithMesRouters,
        ...sithMesIIRouters,
        ...layoutRouters,
        //mintal
        ...mintalMesRouters,
        ...partyBuilding,
        {
            path: '*',
            component: Error404,
            meta: {requiresAuth: false},
        },
        {
            path: '/unauthorized',
            name: 'Unauthorized',
            component: Unauthorized,
            meta: {requiresAuth: false},
        },
        {
            path: '/login',
            name: 'Login',
            component: EmLogin,
            meta: {requiresAuth: false},
        },
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth !== false) && !jwt) {
        next({name: 'Login'})
    } else {
        next()
    }
})

export default router
